// src/services/ApiFunctions.js
import axios from "axios";

export const BASE_URL = "https://appgames.fikriti.com/api/v1/";

// إنشاء instance من axios مع إعدادات افتراضية
const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // 10 ثواني timeout
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: false, // تعطيل credentials بشكل افتراضي
});

// Interceptor للـ request لإضافة التوكن تلقائياً
apiClient.interceptors.request.use(
  (config) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const token = user?.token;
      
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (e) {
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor للـ response لمعالجة الأخطاء
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // معالجة خطأ 401 (unauthorized)
    if (error.response?.status === 401) {
      try {
        const userData = localStorage.getItem('user');
        if (userData) {
          const user = JSON.parse(userData);
          // إذا كان المستخدم أدمن، لا نقوم بإعادة التوجيه التلقائي
          const isAdminUser = user.user && user.user.isAdmin && user.user.email === 'admin@gmail.com';
          const hasToken = user.token && user.token.length > 0;
          
          if (isAdminUser && hasToken) {
            // console.log("ApiFunctions: الأدمن - لا إعادة توجيه تلقائي");
            return Promise.reject(error);
          }
        }
        // للمستخدمين العاديين فقط
        // console.log("ApiFunctions: إعادة توجيه للمستخدم العادي");
        localStorage.removeItem("user");
        window.location.href = "/login";
      } catch (e) {
        // fallback behavior
        localStorage.removeItem("user");
        window.location.href = "/login";
      }
    }
    
    return Promise.reject(error);
  }
);

// دالة للتحقق من الأدمن
const isAdmin = () => {
  try {
    const userData = localStorage.getItem("user");
    if (!userData) return false;
    const user = JSON.parse(userData);
    
    // التحقق من الأدمن: يجب أن يكون isAdmin: true و email صحيح و token موجود
    const isAdminUser = user.user?.isAdmin === true && user.user?.email === "admin@gmail.com";
    const hasToken = user.token && user.token.length > 0;
    
    return isAdminUser && hasToken;
  } catch (e) {
    return false;
  }
};

// بيانات تجريبية للأدمن
const getMockDataForAdmin = (endpoint) => {
  // console.log("ApiFunctions: استخدام بيانات تجريبية للأدمن", endpoint);
  
  if (endpoint.includes('countries')) {
    return {
      data: {
        data: [
          { 
            id: 1, 
            name: "مصر", 
            flag: "images/flags/egypt.png", 
            code: "EG",
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 2, 
            name: "السعودية", 
            flag: "images/flags/saudi.png", 
            code: "SA",
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 3, 
            name: "الإمارات", 
            flag: "images/flags/uae.png", 
            code: "AE",
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 4, 
            name: "الكويت", 
            flag: "images/flags/kuwait.png", 
            code: "KW",
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 5, 
            name: "قطر", 
            flag: "images/flags/qatar.png", 
            code: "QA",
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          }
        ],
        total: 5,
        per_page: 10,
        current_page: 1,
        last_page: 1
      }
    };
  }
  
  if (endpoint.includes('categories')) {
    return {
      data: {
        data: [
          { 
            id: 1, 
            name: "الرياضة", 
            description: "أسئلة رياضية متنوعة", 
            image: "images/categories/sports.jpg", 
            country_id: 1,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 2, 
            name: "التاريخ", 
            description: "أسئلة تاريخية", 
            image: "images/categories/history.jpg", 
            country_id: 1,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 3, 
            name: "العلوم", 
            description: "أسئلة علمية", 
            image: "images/categories/science.jpg", 
            country_id: 2,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 4, 
            name: "الجغرافيا", 
            description: "أسئلة جغرافية", 
            image: "images/categories/geography.jpg", 
            country_id: 2,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 5, 
            name: "الثقافة العامة", 
            description: "أسئلة ثقافية متنوعة", 
            image: "images/categories/culture.jpg", 
            country_id: 3,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 6, 
            name: "الأدب", 
            description: "أسئلة أدبية", 
            image: "images/categories/literature.jpg", 
            country_id: 3,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          }
        ],
        total: 6,
        per_page: 10,
        current_page: 1,
        last_page: 1
      }
    };
  }
  
  if (endpoint.includes('questions')) {
    return {
      data: {
        data: [
          { 
            id: 1, 
            question_text: "ما هي عاصمة مصر؟", 
            question: "ما هي عاصمة مصر؟",
            type: "mcq", 
            level: "easy", 
            points: 100,
            correct_answer: ["القاهرة"],
            options: ["القاهرة", "الإسكندرية", "الجيزة", "أسوان"],
            category_id: 1,
            media_type: null,
            media_url: null,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 2, 
            question_text: "كم عدد قارات العالم؟", 
            question: "كم عدد قارات العالم؟",
            type: "text", 
            level: "medium", 
            points: 200,
            correct_answer: ["7", "سبعة"],
            category_id: 4,
            media_type: null,
            media_url: null,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 3, 
            question_text: "من هو أول رئيس لمصر؟", 
            question: "من هو أول رئيس لمصر؟",
            type: "mcq", 
            level: "medium", 
            points: 300,
            correct_answer: ["محمد نجيب"],
            options: ["محمد نجيب", "جمال عبد الناصر", "أنور السادات", "حسني مبارك"],
            category_id: 2,
            media_type: null,
            media_url: null,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 4, 
            question_text: "ما هو أكبر كوكب في المجموعة الشمسية؟", 
            question: "ما هو أكبر كوكب في المجموعة الشمسية؟",
            type: "text", 
            level: "easy", 
            points: 150,
            correct_answer: ["المشتري", "كوكب المشتري"],
            category_id: 3,
            media_type: null,
            media_url: null,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 5, 
            question_text: "كم عدد عضلات جسم الإنسان؟", 
            question: "كم عدد عضلات جسم الإنسان؟",
            type: "number", 
            level: "hard", 
            points: 400,
            correct_answer: ["600", "حوالي 600"],
            category_id: 3,
            media_type: null,
            media_url: null,
            status: "active",
            created_at: "2024-01-01T00:00:00.000000Z"
          }
        ],
        total: 5,
        per_page: 10,
        current_page: 1,
        last_page: 1
      }
    };
  }
  
  if (endpoint.includes('users')) {
    return {
      data: {
        data: [
          { 
            id: 1, 
            name: "أحمد محمد", 
            email: "ahmed@example.com", 
            phone: "01234567890",
            status: "active",
            role: "user",
            created_at: "2024-01-01T00:00:00.000000Z",
            updated_at: "2024-01-01T00:00:00.000000Z"
          },
          { 
            id: 2, 
            name: "فاطمة علي", 
            email: "fatma@example.com", 
            phone: "01234567891",
            status: "active",
            role: "user",
            created_at: "2024-01-02T00:00:00.000000Z",
            updated_at: "2024-01-02T00:00:00.000000Z"
          },
          { 
            id: 3, 
            name: "محمد حسن", 
            email: "mohamed@example.com", 
            phone: "01234567892",
            status: "inactive",
            role: "user",
            created_at: "2024-01-03T00:00:00.000000Z",
            updated_at: "2024-01-03T00:00:00.000000Z"
          },
          { 
            id: 4, 
            name: "سارة أحمد", 
            email: "sara@example.com", 
            phone: "01234567893",
            status: "active",
            role: "user",
            created_at: "2024-01-04T00:00:00.000000Z",
            updated_at: "2024-01-04T00:00:00.000000Z"
          },
          { 
            id: 5, 
            name: "عمر خالد", 
            email: "omar@example.com", 
            phone: "01234567894",
            status: "active",
            role: "user",
            created_at: "2024-01-05T00:00:00.000000Z",
            updated_at: "2024-01-05T00:00:00.000000Z"
          }
        ],
        total: 5,
        per_page: 10,
        current_page: 1,
        last_page: 1
      }
    };
  }
  
  // بيانات افتراضية
  return {
    data: {
      data: [],
      total: 0,
      per_page: 10,
      current_page: 1,
      last_page: 1
    }
  };
};

export default class ApiFunctions {
  constructor(endpoint) {
    this.endpoint = endpoint;
    this.fullUrl = BASE_URL + endpoint;
    this.apiClient = apiClient;
  }

  getToken() {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      return user?.token || null;
    } catch (e) {
      return null;
    }
  }

  // headers builder (محسّن)
  getHeaders({
    withAuth = true,
    useCredentials = false,
    isFormData = false,
  } = {}) {
    const headers = {
      Accept: "application/json",
    };

    // لا نضيف Content-Type لو البيانات FormData
    if (!isFormData) {
      headers["Content-Type"] = "application/json";
    }

    if (withAuth) {
      const token = this.getToken();
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
    }

    return {
      headers,
      withCredentials: useCredentials,
      timeout: 10000,
    };
  }

  // GET
  get = async ({ withAuth = true, useCredentials = false } = {}) => {
    try {
      return await apiClient.get(this.endpoint, {
        withCredentials: useCredentials,
      });
    } catch (error) {
      // إذا كان الأدمن وحدث خطأ 401، استخدم البيانات التجريبية
      if (error.response?.status === 401 && isAdmin()) {
        // console.log("ApiFunctions: استخدام البيانات التجريبية للأدمن في get()");
        return getMockDataForAdmin(this.endpoint);
      }
      throw error;
    }
  };

  // GET by ID
  getById = async (id, { withAuth = true, useCredentials = false } = {}) => {
    try {
      return await apiClient.get(`${this.endpoint}/${id}`, {
        withCredentials: useCredentials,
      });
    } catch (error) {
      throw error;
    }
  };

  // GET for edit
  edit = async (id, { withAuth = true, useCredentials = false } = {}) => {
    try {
      return await apiClient.get(`${this.endpoint}/${id}`, {
        withCredentials: useCredentials,
      });
    } catch (error) {
      throw error;
    }
  };

  // POST (محسّن)
  post = async (data, { withAuth = true, useCredentials = false } = {}) => {
    try {
      const isFormData = data instanceof FormData;
      
      const config = {
        withCredentials: useCredentials,
        timeout: 15000, // زيادة timeout
      };

      // للـ FormData
      if (isFormData) {
        config.headers = {
          Accept: "application/json",
        };
        
        if (withAuth) {
          const token = this.getToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        }
      }
      // للـ JSON
      else {
        config.headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        };
        
        if (withAuth) {
          const token = this.getToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        }
      }

      
      const response = await apiClient.post(this.endpoint, data, config);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // PATCH (محسّن)
  patch = async (
    id,
    data,
    { withAuth = true, useCredentials = false } = {}
  ) => {
    try {
      const isFormData = data instanceof FormData;
      
      const config = {
        withCredentials: useCredentials,
      };

      if (isFormData) {
        config.headers = {
          Accept: "application/json",
        };
        
        if (withAuth) {
          const token = this.getToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        }
      }

      return await apiClient.patch(`${this.endpoint}/${id}`, data, config);
    } catch (error) {
      throw error;
    }
  };

  // PATCH POST (للخوادم التي تتطلب POST مع _method=PATCH)
  patchPOST = async (
    id,
    data,
    { withAuth = true, useCredentials = false } = {}
  ) => {
    try {
      const isFormData = data instanceof FormData;

      if (isFormData) {
        // إضافة _method=PATCH للـ FormData
        data.append('_method', 'PATCH');
        
        const config = {
          withCredentials: useCredentials,
          headers: {
            Accept: "application/json",
          }
        };
        
        if (withAuth) {
          const token = this.getToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        }

        return await apiClient.post(`${this.endpoint}/${id}`, data, config);
      }

      return await this.patch(id, data, { withAuth, useCredentials });
    } catch (error) {
      throw error;
    }
  };

  // DELETE
  delete = async (id, { withAuth = true, useCredentials = false } = {}) => {
    try {
      return await apiClient.delete(`${this.endpoint}/${id}`, {
        withCredentials: useCredentials,
      });
    } catch (error) {
      throw error;
    }
  };

  // GET with pagination and optional search
  getWithPagination = async (
    pageNumber,
    searchTerm = "",
    additionalParams = {},
    { withAuth = true, useCredentials = false } = {}
  ) => {
    try {
      let url = `${this.endpoint}?page=${pageNumber}`;
      if (searchTerm.trim() !== "") {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }
      
      // إضافة المعاملات الإضافية مثل status
      Object.keys(additionalParams).forEach(key => {
        if (additionalParams[key] !== undefined && additionalParams[key] !== null) {
          url += `&${key}=${encodeURIComponent(additionalParams[key])}`;
        }
      });
      
      return await apiClient.get(url, {
        withCredentials: useCredentials,
      });
    } catch (error) {
      // إذا كان الأدمن وحدث خطأ 401، استخدم البيانات التجريبية
      if (error.response?.status === 401 && isAdmin()) {
        // console.log("ApiFunctions: استخدام البيانات التجريبية للأدمن في getWithPagination()");
        return getMockDataForAdmin(this.endpoint);
      }
      throw error;
    }
  };
}